//TODO: importar .env si es que se debe usar 
export class AppConfig {

    //____________Start App Config
    static ENVIRONMENTS = {
        PRODUCTION: 0,
        DEVELOPMENT: 1,
        QA: 2
    }

    //Set environment 
    static API_ENVIRONMENT = this.ENVIRONMENTS.DEVELOPMENT;

    //Esto debería ir en .env?
    static KEY = "ZX$JMv6ddlOiCId5QxHpTdEg98&g5w2Te4GOX#RN6TyTxA5q@vp0gJ!$CX3HSXba$ofXi64xxdHqlO4DQt&vUe0ibIYs%2Yz0*Bv";
    static API_KEY = "h%DY7tPw*MG22lBMdcnWHQPSKQ4S#TfnY5hfYH1D26z9QhFnR#";

    //Registrar todas las url para los diferentes ambientes.
    static apiUrls = (() => {
        let urls = {};
        // urls[this.ENVIRONMENTS.DEVELOPMENT] = 'https://apiabrahamdelgado.azurewebsites.net/api';
        urls[this.ENVIRONMENTS.DEVELOPMENT] = 'https://bastetderma.com/swagger/api';
        urls[this.ENVIRONMENTS.QA] = 'https://bastetderma.com/swagger/api';
        // urls[this.ENVIRONMENTS.QA] = 'https://apiabrahamdelgado.azurewebsites.net/api';
        // http://apiabrahamdelgado.azurewebsites.net
        // http://apiatelier.azurewebsites.net
        return urls;
    })();

    //Establecer el ambiente para iniciar la app
    static API_URL = this.apiUrls[this.API_ENVIRONMENT];
}

